var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.307,
    height: 20.338,
    viewBox: "0 0 20.307 20.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 15.595,
    height: 1.607,
    rx: 0.803,
    transform: "translate(20.307 1.136) rotate(135)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 8.764,
    height: 1.607,
    rx: 0.803,
    transform: "translate(20.002 0.364) rotate(90)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 8.764,
    height: 1.607,
    rx: 0.803,
    transform: "translate(19.942 1.912) rotate(180)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M17.5,59.765V66.74a.894.894,0,0,1-.894.894H.894A.894.894,0,0,1,0,66.74V51.023a.893.893,0,0,1,.894-.893H7.869a.807.807,0,0,1,.8.673h0c0,.011,0,.02,0,.031a.1.1,0,0,0,0,.018V51a.252.252,0,0,0,0,.028.263.263,0,0,0,0,.033h0a.807.807,0,0,1-.8.682H2.508a.893.893,0,0,0-.894.893V65.126a.894.894,0,0,0,.894.894H15a.894.894,0,0,0,.894-.894V59.765a.807.807,0,1,1,1.614,0Z",
    transform: "translate(0 -47.296)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M171.677,62.36v.363c0-.015-.007-.031-.01-.046h0c0-.011,0-.023,0-.033a.254.254,0,0,1,0-.028v-.167c0-.006,0-.02,0-.031h0C171.669,62.4,171.673,62.379,171.677,62.36Z",
    transform: "translate(-163.001 -58.909)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M340.44,54.47l-.015-.015-.028-.027,0,0-.045-.046c.016.014.032.028.047.043S340.427,54.455,340.44,54.47Z",
    transform: "translate(-323.181 -51.332)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M329.38,50.13a.807.807,0,0,1,.234.064.892.892,0,0,0-.333-.064Z",
    transform: "translate(-312.67 -47.296)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M340.44,54.47l-.015-.015-.028-.027,0,0-.045-.046c.016.014.032.028.047.043S340.427,54.455,340.44,54.47Z",
    transform: "translate(-323.181 -51.332)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M171.677,63.614a.857.857,0,0,1-.01.126c0-.011,0-.023,0-.033a.254.254,0,0,1,0-.028v-.167c0-.006,0-.02,0-.031A.78.78,0,0,1,171.677,63.614Z",
    transform: "translate(-163.001 -59.973)",
    fill: "#939393"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.95519c6a23f963c2a09431d9e3e9546f.svg";
export { ForwardRef as ReactComponent };